import styled from "styled-components";

// 모달 안의 버튼
const ModalButton = styled.button`
    margin-right: 1rem;
    background-color: #282828;
    color: white;
    border: none;
    width: 6rem;
    border-radius: 0.4rem;
    padding: 0.4rem;
    font-size: 0.9rem;
`

export default ModalButton